<div mat-dialog-content style="margin: 0; padding: 0;min-width: 310px; overflow: hidden;">
  <div class="base-dialog-header" style="display: flex; justify-content: space-between; align-items: center;">
    <div style="padding-left: 15px; font-weight: 400; font-size: 13px;">
      <ng-content select="[base-dialog-title]"></ng-content>
    </div>
    <div>
      <div class="close-button" style="display: flex; justify-content: center; align-items: center; width: 55px; height: 50px; font-size: 16px; color: inherit; background-color: inherit; cursor: pointer;" (click)="close()" [matTooltip]="closeButtonTip">
        <span class="fal fa-times"></span>
      </div>
    </div>
  </div>
  <ng-content select="[base-dialog-body]"></ng-content>
  <ng-content select="[base-dialog-actions]"></ng-content>
</div>
